	import { Observable } from 'rxjs'
	import { interval as intervalObs, timer, of } from 'rxjs'
	import { first as firstObs, map as mapObs, skipWhile, toPromise } from 'rxjs/operators'

	import promiseMap from './_promise-map'
    import services from '../../utils/services'

    import rxSubs from './rx-subs.js'

	const VM_PROP = 'vm'
	const INSTANCE_PROMISE_POOL = 'instance_promise'

	const props = {}

	const methods = {

		beforeInit () {},

		async init () {
			let createPromise

		    const ident = this.makeSelfIdent()

		    if (ident && this.$identityMap.has(ident, INSTANCE_PROMISE_POOL)) {
		      createPromise = this.$identityMap.get(ident, INSTANCE_PROMISE_POOL)
		    } else {
		      createPromise = Promise.resolve(this.createOlObject())
		      if (ident) {
		        this.$identityMap.set(ident, createPromise, INSTANCE_PROMISE_POOL)
		      }
		    }

		    this._olObject = await createPromise
		    this._olObject[VM_PROP] || (this._olObject[VM_PROP] = [])

		    if (!this._olObject[VM_PROP].includes(this)) { // for loaded from IdentityMap
		      this._olObject[VM_PROP].push(this)
		    }

			++this.rev
		},

		createOlObject () {
		    throw new Error('Not implemented method')
		},

		deinit () {
		    const ident = this.makeSelfIdent()
		    if (ident) {
		      this.$identityMap.unset(ident, INSTANCE_PROMISE_POOL)
		    }
		    if (this._olObject) {
		      this._olObject[VM_PROP] = this._olObject[VM_PROP].filter(vm => vm !== this)
		      this._olObject = undefined
		    }
		},

		getServices () {
			return services.methods.getServices.call(this)
		},
		/**
		* @return {void|Promise<void>}
		* @protected
		* @abstract
		*/
		mount () {
			throw new Error('Not implemented method')
		},
		/**
		* @return {void|Promise<void>}
		* @protected
		* @abstract
		*/
		unmount () {
			throw new Error('Not implemented method')
		},
		/**
		* Refresh internal ol objects
		* @return {Promise<void>}
		*/
		refresh () {
			return new Promise(resolve => {
			  let done = () => {
			    ++this.rev
			    resolve()
			  }
			  if (this.$olObject && _.isFunction(this.$olObject.changed)) {
			    this.$olObject.once('change', done)
			    this.$olObject.changed()
			  } else {
			    done()
			  }
			})
		},

		async remount () {
			await this.unmount()
			await this.mount()
		},
		/**
		* Only for internal purpose to support watching for properties
		* for which OpenLayers doesn't provide setters.
		* @return {Promise}
		* @protected
		*/
		async recreate () {
			await this.unmount()
			await this.init()
			await this.mount()
		},

	}


	export default {
		VM_PROP,
		INSTANCE_PROMISE_POOL,
		mixins: [promiseMap, rxSubs, services],
		methods,
		data () {
			return {
				rev: 0
			}
		},
		created () {
			this._olObject = undefined

			this._createPromise = Promise.resolve(this.beforeInit())
			      .then(this.init)
			      .then(() => {
			        // logdbg('created', this.$options.name)
			        this.$emit('created', this)
			        return this
			})


			this._mountPromise = intervalObs(100)
				.pipe(skipWhile(() => !this._mounted))
				.pipe(firstObs())
				.pipe(mapObs(() => this))
				.toPromise(Promise)

			Object.defineProperties(this, {
				$olObject: {
			        enumerable: true,
			        get: () => this._olObject,
				},
				$createPromise: {
					enumerable: true,
					get: () => this._createPromise,
				},
				$mountPromise: {
					enumerable: true,
					get: () => this._mountPromise,
				}
			})
		},
		mounted () {
			// this.mount()
		    this.$createPromise.then(() => {
		    	// console.log("Mounting")
		    	// console.log(this)
		    	this.mount()

		    })
		      .then(() => {
		        this._mounted = true
		        this.$emit('mounted', this)
		        // logdbg('mounted', this.$options.name)
		      })
		},
		destroyed () {
			this.$mountPromise.then(this.unmount)
				.then(this.deinit)
				.then(() => {
				this.$emit('destroyed', this)
				// logdbg('destroyed', this.$options.name)
			})
},
	}



// WEBPACK FOOTER //
// ./resources/js/map/MapComponents/mixins/compilers/_compiler.js